import React, { useState } from "react";
import { FiCalendar, FiPlus } from "react-icons/fi";
import AssignmentsList from "./components/AssignmentsList";
import NewAssignmentModal from "./components/NewAssignmentModal";
import EditAssignmentModal from "./components/EditAssignmentModal";

export default function TabAssignments({ classInfo, students = [] }) {
  const [openNew, setOpenNew] = useState(false);
  const [editing, setEditing] = useState(null);

  return (
    <div className="space-y-4">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
        <div>
          <h3 className="flex items-center gap-2 text-xl font-bold text-slate-900">
            <FiCalendar className="text-blue-600" /> Bài tập/kiểm tra
          </h3>
          <p className="mt-1 text-sm text-slate-500">
            Giao bài, chỉnh sửa assignment và theo dõi tiến độ làm bài của từng học viên.
          </p>
        </div>

        <button
          type="button"
          onClick={() => setOpenNew(true)}
          className="inline-flex items-center justify-center gap-2 rounded-xl bg-blue-600 px-4 py-3 text-sm font-semibold text-white transition hover:bg-blue-700"
        >
          <FiPlus /> Giao bài tập
        </button>
      </div>

      <AssignmentsList classInfo={classInfo} students={students} onEdit={setEditing} />

      <NewAssignmentModal
        open={openNew}
        onClose={() => setOpenNew(false)}
        classInfo={classInfo}
        students={students}
      />

      <EditAssignmentModal
        open={!!editing}
        onClose={() => setEditing(null)}
        classInfo={classInfo}
        students={students}
        assignment={editing}
      />
    </div>
  );
}
